import { useState } from 'react';
import type { LayoutChangeEvent } from 'react-native';
import { useWindowDimensions } from 'react-native';

const LARGE_COLUMN_MAX = 600;
const MODAL_WIDTH_FRACTION = 0.92;
const MODAL_HEIGHT_FRACTION = 0.88;

export function useModalCardLayout() {
  const { width: windowWidth, height: windowHeight } = useWindowDimensions();
  const [measuredWidth, setMeasuredWidth] = useState(0);

  const fallbackCardWidth = Math.min(LARGE_COLUMN_MAX, Math.round(windowWidth * MODAL_WIDTH_FRACTION));
  const itemWidth = measuredWidth > 0 ? measuredWidth : fallbackCardWidth;
  const cardWidth = fallbackCardWidth;
  const cardHeight = Math.round(windowHeight * MODAL_HEIGHT_FRACTION);

  const onCardLayout = (e: LayoutChangeEvent) => {
    const w = e.nativeEvent.layout.width;
    if (w > 0) {
      setMeasuredWidth((prev) => (Math.abs(w - prev) > 0.5 ? w : prev));
    }
  };

  return { itemWidth, cardWidth, cardHeight, maxWidth: LARGE_COLUMN_MAX, onCardLayout };
}
